import React from 'react';
import './conversation-summary.scss';
import {
  APP_TYPE,
  ConversationData,
  ConversationStatusGroup,
  getIsFieldOps,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { StatusClassMap } from '../hooks/get-conversation-list';
import { camelCase, startCase } from 'lodash';
import { SVGS } from '../../assets';
import { TagsKey } from '../contstants';
import { ConversationTags } from '../conversation-tags/conversation-tags';
import { ReactComponent as UserFilled } from '@zonofi/svg-icons/user-filled.svg';

interface ConversationSummaryProps extends ConversationData {
  onAssignTeamMember: () => void;
  findStatusCategory: (status: string) => ConversationStatusGroup;
  findTagType: (tag: string) => TagsKey;
  onAddTag: () => void;
}

export const ConversationSummary: React.FC<ConversationSummaryProps> = ({
  onAssignTeamMember,
  findStatusCategory,
  findTagType,
  onAddTag,
  status = '',
  metadata,
  title,
  assignedTo = [],
  customerLifeCyclePaths = [],
  queryType,
}) => {
  const { tags = [], campaignName } = metadata ?? {};
  const isAssigned = assignedTo.length > 0;
  const primaryAssignee = assignedTo[0]?.teamMemberName ?? '';
  const summaryText = (title || '').trim();
  const isFieldOps = useAppSelector(getIsFieldOps);

  return (
    <div className="conversation-summary font-semibold">
      <div className="conversation-summary-top">
        <div className="conversation-summary-status-wrap">
          <div
            className={`conversation-status status-details ${StatusClassMap[findStatusCategory(status)]}`}
          >
            <div
              className={`marker ${StatusClassMap[findStatusCategory(status)]}`}
            />
            {startCase(status)}
          </div>
          {isAssigned ? (
            <div className="conversation-summary-assigned-state font-semibold">
              <UserFilled height={16} width={16} color="#249f6c" />
              Assigned
            </div>
          ) : (
            <div className="conversation-summary-unassigned-state font-semibold">
              Not Assigned
            </div>
          )}
        </div>
        {!isFieldOps && !isAssigned && (
          <button
            className="conversation-summary-assign-link font-semibold"
            onClick={onAssignTeamMember}
          >
            <img src={SVGS.PlusIconNew} width={16} height={16} alt="" />
            Assign Team Member
          </button>
        )}
      </div>
      <div className="conversation-summary-divider" />
      {campaignName && (
        <div className="conversation-summary-campaign font-semibold">
          <img src={SVGS.CampaignIcon} width={16} height={16} alt="" />
          Campaign Source: {campaignName}
        </div>
      )}
      {summaryText && (
        <div className="conversation-summary-summary font-bold">
          {summaryText}
        </div>
      )}
      <div className="conversation-summary-tags">
        <ConversationTags
          customerLifeCyclePaths={customerLifeCyclePaths}
          tags={tags}
          findTagType={findTagType}
          visibleCount={tags.length}
          queryType={queryType}
          // onAddTag={onAddTag}
        />
      </div>
      {isAssigned && (
        <span className="conversation-summary-assignee">
          <span className="conversation-summary-assignee-text">
            Assigned to
          </span>
          <span className="conversation-summary-assignee-names">
            {startCase(camelCase(primaryAssignee))} (Team Member)
          </span>
          <span
            className="conversation-summary-assignee-modify"
            onClick={onAssignTeamMember}
          >
            Modify
          </span>
        </span>
      )}
    </div>
  );
};
